import { buildExternalWebUrl } from '@/utils/publicShareUrls';

export const ONBOARDING_CHECKOUT_RETURN_PARAM = 'onboarding';
export const ONBOARDING_CHECKOUT_SUCCESS_VALUE = 'complete';
export const ONBOARDING_CHECKOUT_CANCEL_VALUE = 'resume';

type HostedCheckoutProvider = 'stripe' | 'paypal';

export interface OnboardingCheckoutContext {
  source?: string;
  paywallType?: string;
}

export function isOnboardingHostedCheckout(
  context: OnboardingCheckoutContext
): boolean {
  return context.source === 'onboarding_flow' && context.paywallType === 'onboarding';
}

export function buildOnboardingHostedCheckoutUrls(
  provider: HostedCheckoutProvider
): { successUrl: string; cancelUrl: string } {
  return {
    successUrl: buildExternalWebUrl('/welcome-premium', {
      checkout: 'success',
      provider,
      [ONBOARDING_CHECKOUT_RETURN_PARAM]: ONBOARDING_CHECKOUT_SUCCESS_VALUE,
    }),
    cancelUrl: buildExternalWebUrl('/onboarding', {
      checkout: 'canceled',
      provider,
      [ONBOARDING_CHECKOUT_RETURN_PARAM]: ONBOARDING_CHECKOUT_CANCEL_VALUE,
    }),
  };
}

export function isOnboardingCheckoutSuccessReturn(
  searchParams: Pick<URLSearchParams, 'get'>
): boolean {
  return (
    searchParams.get('checkout') === 'success' &&
    searchParams.get(ONBOARDING_CHECKOUT_RETURN_PARAM) ===
      ONBOARDING_CHECKOUT_SUCCESS_VALUE
  );
}
